<template>
  <v-container>
    <v-layout row wrap>
      <!-- Heading -->
      <v-flex xs12 class="text-xs-center">
        <div class="headline">{{ $t('rms_invite_peoples_label') }}</div>
        <div class="subheading mt-1">{{ $t('rms_invitation_creation_header') }}.</div>
      </v-flex>
      <v-flex xs12 class="mt-5">
        <!-- Invitation form -->
        <v-form ref="form" lazy-validation>
          <!-- Emails input field -->
          <v-textarea
            v-model="invitee_emails"
            outline
            :hint="$t('rms.invitation_form.email_field.hint')"
            :label="$t('rms.invitation_form.email_field.placeholder')"
            :rules="[rules.required]"
          ></v-textarea>
          <!-- Phone number input field -->
          <v-text-field
            outline
            type="number"
            :rules="[rules.exact_length(10)]"
            v-model="invitee_contact"
            :label="$t('rms.invitation_form.contact_field.placeholder')"
          ></v-text-field>
          <!-- Expiry days select box -->
          <v-select
            outline
            :items="timeLimits"
            :rules="[rules.required]"
            item-text="title"
            item-value="value"
            v-model="expire_in_days"
            :label="$t('rms.invitation_form.expiry_date_field.placeholder')"
            @change="calculateDateFromDays()"
          ></v-select>
          <!-- Expiry date field (value depends on selected expiry days) -->
          <v-text-field
            outline
            :label="$t('rms_expire_link_label')"
            v-if="expire_in_days"
            readonly
            :value="moment(expiry_date).format('D MMM YYYY')"
          ></v-text-field>

          <v-layout row wrap>
            <v-flex xs12 sm12 md6>
              <!-- checkbox for screener allow permission -->
              <v-checkbox
                class="title mt-0"
                v-model="is_screener_allowed"
                :label="$t('rms.invitation_form.screeners_field.label')"
                color="green"
              ></v-checkbox>
            </v-flex>
            <v-flex xs12 sm12 md6>
              <!-- Checkbox for refine search in filters allow permission -->
              <v-checkbox
                class="title mt-0"
                v-model="is_search_filters_allowed"
                :label="$t('rms.invitation_form.refine_search_field.label')"
                color="green"
              ></v-checkbox>
            </v-flex>
          </v-layout>
        </v-form>
      </v-flex>
      <v-flex xs12>
        <v-btn
          color="green"
          block
          @click="createInvitation()"
        >{{ $t('rms.invitation_form.create_and_send.label') }}</v-btn>
      </v-flex>
      <!-- When invitation will get create this dialog will open with invitation details -->
      <InvitationSentDialog v-model="dialog" :dialog="dialog" :created_links="created_links"></InvitationSentDialog>
    </v-layout>
  </v-container>
</template>

<script>
import rules from "@/validation";
import { mapGetters } from "vuex";
import i18n from "@/i18n";
import InvitationSentDialog from "@/components/invitation/SentDialog";

export default {
  data: () => ({
    search: null,
    rules,
    dialog: false,
    expire_in_days: null,
    expiry_date: null,
    modal: false,
    invitee_emails: null,
    invitee_contact: null,
    is_screener_allowed: false,
    is_search_filters_allowed: true,
    created_links: []
  }),

  components: {
    InvitationSentDialog
  },

  mounted() {
    this.$store.commit("app/set_toolbar_header", {
      header: i18n.t("rms.toolbar.header.create_invitation")
    });
  },

  computed: {
    timeLimits() {
      return this.DEFINES.TIME_LIMITS;
    },
    ...mapGetters({
      movie_filters: "filter/getApplied"
    })
  },

  methods: {
    async createInvitation() {
      if (this.$refs.form.validate()) {
        var self = this;
        this.$store
          .dispatch("avails/createInvitation", {
            emails: this.invitee_emails.split(","),
            contact: this.invitee_contact,
            expiry_date: this.moment(this.expiry_date).format("YYYY-MM-DD"),
            is_screener_allowed: this.is_screener_allowed,
            is_search_filters_allowed: this.is_search_filters_allowed,
            movie_filters: JSON.stringify(this.movie_filters)
          })
          .then(response => {
            this.$refs.form.reset();
            self.created_links = response.links;
            self.dialog = true;
          });
      }
    },
    calculateDateFromDays() {
      let current_date = this.moment();
      this.expiry_date = this.moment(current_date).add(
        this.expire_in_days,
        "days"
      );
    }
  }
};
</script>

<style>
.invitation_create .v-icon {
  color: orange !important;
}
</style>
